import { jsx as _jsx } from "react/jsx-runtime";
import { AcademicPolicyType } from '@src/types';
import { getPaymentRequestItemAdjustments, isScholarshipItem, } from '@src/utilities/paymentRequestHelper';
import { isEmpty } from 'lodash';
import { useLocale } from 'pe-core-frontend';
export const getSystemReasons = (item) => {
    const reasons = [];
    if (isEmpty(item.calculations) || item.amountToPay === null || item.amountToPay === undefined) {
        return reasons;
    }
    const adjustments = getPaymentRequestItemAdjustments(item);
    if (adjustments.SCHOLARSHIP.deduction > 0) {
        reasons.push({
            reason: 'Scholarship applied: -{amount}',
            values: { amount: adjustments.SCHOLARSHIP.deduction },
        });
    }
    if (adjustments.gradePayoutPercent < 100) {
        if (adjustments.gradePayoutPercent === 0) {
            reasons.push({
                reason: adjustments.policyType === AcademicPolicyType.CGPA
                    ? 'Did not meet cumulative grade requirements for reimbursement'
                    : 'Did not meet grade requirements for reimbursement',
                values: {},
            });
        }
        else {
            reasons.push({
                reason: adjustments.policyType === AcademicPolicyType.CGPA
                    ? 'CGPA based payout: {percent}%'
                    : 'Grade based payout: {percent}%',
                values: { percent: adjustments.gradePayoutPercent },
            });
        }
    }
    if (!isScholarshipItem(item) &&
        adjustments.GRADE_BASED_PAYOUT.result > 0 &&
        adjustments.FUNDING_APPLIED.result < adjustments.GRADE_BASED_PAYOUT.result) {
        reasons.push({
            reason: 'Funding available: {amount}',
            values: { amount: adjustments.FUNDING_APPLIED.result },
        });
    }
    return reasons;
};
export const PaymentItemReason = ({ item, currency, }) => {
    const { t, formatCurrency } = useLocale();
    const reasons = getSystemReasons(item).map(({ reason, values }) => {
        return t(reason, {
            values: {
                ...values,
                amount: values.amount !== undefined ? formatCurrency(values.amount, currency, true) : undefined,
            },
        });
    });
    if (reasons.length === 0) {
        return null;
    }
    return (_jsx("div", { children: _jsx("ul", { className: '', children: reasons.map(reason => (_jsx("li", { children: reason }, reason))) }) }));
};
